import React, { useEffect, useState } from 'react';
import DialForm from './DialForm';
import { useParams } from 'react-router-dom';
import { api, endpoint } from '../../api';

const EditDial = () => {
    const { id } = useParams()
    const [dial, setDial] = useState({})

    const getDial = async () => {
        const { result, success } = await api.get(endpoint.dial + '/' + id)
        if (success) {
            setDial(result)
        }
    }

    useEffect(() => {
        getDial()
    }, [])



    return (
        <div>
            {
                Object.keys(dial).length > 0 && <DialForm mode="update" data={dial} />
            }
        </div>
    );
};

export default EditDial;